import {
  Card,
  CardContent,
  CardActions,
  Typography,
  IconButton,
  Stack,
  Divider,
  Collapse,
  Box,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import { userInfoGroups } from "./EditUserDialog";

function InfoRow({ label, value }) {
  if (!value) return null;

  return (
    <Box display="flex" gap={1}>
      <Typography
        variant="body2"
        sx={{ minWidth: 140, color: "text.secondary" }}
      >
        {label}:
      </Typography>
      <Typography variant="body2">{value}</Typography>
    </Box>
  );
}

export default function UserCard({
  user,
  onEdit,
  onDelete,
  state,
}) {
  const [open, setOpen] = useState({
    "Bổ sung": false,
    "Thông tin khác": false,
  });

  

  const toggle = (group) =>
    setOpen((prev) => ({ ...prev, [group]: !prev[group] }));

    const sxByState = {
    new: { bgcolor: "success.light" },
    edited: { bgcolor: "warning.light" },
    deleted: { bgcolor: "error.light" },
    };

  return (
    <Card
      sx={{
        maxWidth: 420,
        borderWidth: 2,
        transition: "all .2s",
        ...sxByState[state],
      }}
    >
      <CardContent>
        {/* Header */}
        <Typography variant="h6" gutterBottom>
          {user.name || user.phapDanh}
        </Typography>

        {Object.entries(userInfoGroups).map(([groupName, fields], index) => {
          const isBase = groupName === "Cơ bản";
          const isOpen = isBase || open[groupName];

          // Check if group has any data
          const hasData = fields.some(({ key }) => user[key]);
          if (!hasData) return null;

          return (
            <Box key={groupName}>
              {!isBase && <Divider sx={{ my: 1.2 }} />}

              {/* Group header */}
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                sx={{ cursor: isBase ? "default" : "pointer" }}
                onClick={() => !isBase && toggle(groupName)}
              >
                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                  {groupName}
                </Typography>

                {!isBase && (
                  <ExpandMoreIcon
                    sx={{
                      transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "0.2s",
                    }}
                  />
                )}
              </Box>

              {/* Group content */}
              <Collapse in={isOpen} timeout="auto" unmountOnExit={!isBase}>
                <Stack spacing={0.5} sx={{ mt: 0.5 }}>
                  {fields.map(({ key }) => (
                    <InfoRow key={key} label={key} value={user[key]} />
                  ))}
                </Stack>
              </Collapse>
            </Box>
          );
        })}
      </CardContent>

      {/* Actions */}
      <CardActions sx={{ justifyContent: "flex-end" }}>
        <IconButton size="small" onClick={onEdit}>
          <EditIcon />
        </IconButton>
        <IconButton size="small" color="error" onClick={onDelete}>
          <DeleteIcon />
        </IconButton>
      </CardActions>
    </Card>
  );
}